<div
  class="network-status-banner"
  [class.offline]="isOffline"
  [class.back-online]="isBackOnline"
  *ngIf="isVisible"
  @slideDown
>
  <div class="banner-content">
    <!-- Offline State -->
    <ng-container *ngIf="isOffline">
      <div class="banner-icon">
        <i class="fa-light fa-wifi-slash"></i>
      </div>
      <div class="banner-text">
        <span class="banner-message">{{ 'NETWORK_STATUS_OFFLINE' | translate }}</span>
      </div>
      <div class="status-indicator offline-indicator">
        <span class="pulse-dot"></span>
      </div>
    </ng-container>

    <!-- Back Online State -->
    <ng-container *ngIf="isBackOnline">
      <div class="banner-icon">
        <i class="fa-light fa-wifi"></i>
      </div>
      <div class="banner-text">
        <span class="banner-message">{{ 'NETWORK_STATUS_BACK_ONLINE' | translate }}</span>
      </div>
      <div class="status-indicator online-indicator">
        <i class="fa-solid fa-check"></i>
      </div>
    </ng-container>
  </div>
</div>
